var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopitt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2837 4.4487V2.62787C17.2837 1.62368 16.4671 0.807032 15.4629 0.807032H3.62749C2.12166 0.807032 0.89624 2.03245 0.89624 3.53828V14.4633C0.89624 16.4671 2.52953 17.1945 3.62749 17.1945H17.2837C18.2879 17.1945 19.1046 16.3779 19.1046 15.3737V6.26953C19.1046 5.26534 18.2879 4.4487 17.2837 4.4487ZM15.4629 12.6424H13.6421V9.00078H15.4629V12.6424ZM3.62749 4.4487C3.39308 4.43821 3.17174 4.33771 3.00957 4.16812C2.8474 3.99854 2.75689 3.77293 2.75689 3.53828C2.75689 3.30363 2.8474 3.07803 3.00957 2.90844C3.17174 2.73885 3.39308 2.63835 3.62749 2.62787H15.4629V4.4487H3.62749Z",
    fill: "#219653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopitt);
export default __webpack_public_path__ + "static/media/topitt.be6445cb4e6b1311f742f1f4036dbd80.svg";
export { ForwardRef as ReactComponent };